<template>
  <list-table
    :url="url"
    title="شارژ موجود"
    :fields="fields"
    :params="params"
  ></list-table>
</template>
  <script>
  
/**
 * TableShowData component is used to display data in a tabular format.
 */
 import TableShowData from "../../components/table";

/**
 * persianDate is a helper function used to format date in persian format
 * Uncomment the import statement if it is being used in the component.
 */
// import persianDate from '../../helpers/persianDate';

/**
 * SET_BREADCRUMB is a Vuex action used to set the breadcrumb.
 */
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "chargeAvailableList",
  /**
   * Data object containing the properties used by the component.
   *
   * @property {string} url - The API endpoint for fetching data.
   * @property {Array} fields - The fields to be displayed in the table.
   * @property {Array} params - The parameters to be used in the API call.
   */
  data() {
    return {
      url: "refund/creditors",
      fields: [
        {
          key: "name",
          label: "نام کاربر",
        },
        {
          key: "mobile",
          label: "شماره تماس",
        },
        {
          key: "credit",
          label: "موجودی (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
          tdClass: "ltr",
        },
        // {
        //   key: "status",
        //   label: "تاریخ آخرین شارژ",
        //   formatter(value , key,item){
        //       return persianDate.getDateByFormat(value);
        //   }
        // },
        // {
        //   key: "status",
        //   label: "مبلغ آخرین شارژ (ریال)",
        //   formatter(value , key,item){
        //       return Number(value).toLocaleString()
        //   }
        // },
      ],
      params: [],
    };
  },
  components: {
    "list-table": TableShowData,
  },
  /**
   * Lifecycle hook called when the component is mounted.
   * Dispatch the SET_BREADCRUMB action to set the breadcrumb.
   */
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "شارژ موجود ریفاند" }]);
  },
};
</script>
  <style>
.ltr {
  direction: ltr;
}
</style>